<template>
    <div id="app" class="ifr">
        <Warnings/>
    </div>
</template>
<script>
import Warnings from '@/views/Warnings'
export default {
    components: {
        Warnings
    }
}
</script>
